import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import rankarsLogo from "../../assets/images/shourbh.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { httpRequest } from "../../redux/Action";
import { API_END_POINTS } from "../../api/ApiEndPonts";

  const menuItems = [
    { name: "Dashboard", icon: "bi-grid-1x2", link: "/user/dashboard" },
    { name: "Qbank", icon: "bi-journal-text", link: "/user/subjects" },
    {
      name: "Test Series",
      icon: "bi-card-checklist",
      link: "/user/test-series",
    },
    {
      name: "PYQ",
      icon: "bi-file-earmark-text",
      link: "/user/previous-year-papers",
    },
    { name: "Courses", icon: "bi-play-btn", link: "/user/course" },
    { name: "Settings", icon: "bi-gear", link: "/user/setting" },
  ];

  
function UserNav({ open, setOpen, isMobile, collapsed, setCollapsed }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();


    const userGetMeResponse = useSelector(
      (state) => state.apiReducer.userGetMe?.response
    );
     const userLogout =
    useSelector((state) => state.apiReducer.userLogout);

      const { response, loading, error } = userLogout || {};

    const userData = userGetMeResponse?.data || {};
  
    const user = {
      name: userData?.name || "User",
      email: userData?.email || "user@example.com",
      plan: userData?.plan || "Free",
      duration: userData?.duration || "30 days",
      expiry: userData?.expiry,
      testsAttempted: userData?.testsAttempted || 0,
      accuracy: userData?.accuracy || 0,
      rank: userData?.rank || "-",
    };



  useEffect(() => {
  if (response?.ok ===  true) {
    console.log("Logout Success");

    // redirect
    navigate("/user/login");
  }
}, [response]);


 const handleLogout = () => {
  dispatch(
    httpRequest({
      key: API_END_POINTS.userLogout.KEY,
      onSuccess: (res) => {
        console.log("Logout Success:", res);
      },

      onError: (err) => {
        console.log("Logout Error:", err);
      },
     
    })
  );
};



  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        color: "#fff",
      }}
    >
     {/* TOP CONTAINER */}
<div style={{ position: "relative", marginBottom: "20px" }}>

  {/* Toggle Button (Top Right) */}
  <button
    onClick={() =>
      isMobile ? setOpen(!open) : setCollapsed(!collapsed)
    }
    style={{
      position: "absolute",
      top: "0",
      right: "0",
      background: "rgba(255,255,255,0.1)",
      border: "none",
      color: "#fff",
      fontSize: "22px",
      cursor: "pointer",
      borderRadius: "8px",
      padding: "6px 15px",
    }}
  >
    {!collapsed ? <FaAngleLeft /> : <FaAngleRight />}
  </button>

  {/* LOGO */}
  {!collapsed && (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: "10px",
    }}
  >
    <img
      src={rankarsLogo}
      alt="logo"
      style={{ width: "110px", objectFit: "contain" }}
    />
  </div>
)}

  {/* Divider */}
  {!collapsed && (
    <div
      style={{
        height: "1px",
        background: "rgba(255,255,255,0.1)",
        margin: "15px 0",
      }}
    />
  )}

  {/* PROFILE */}
  {!collapsed && (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "rgba(255,255,255,0.05)",
        padding: "12px",
        borderRadius: "12px",
      }}
    >

<p
  style={{
    margin: 0,
    fontSize: "14px",
    opacity: 0.7,
    maxWidth: "150px",     // 👈 IMPORTANT (width fix)
  
  }}
>
   Welcome 👋 {user.name}
</p>
     
    </div> 
  )}
</div>

      {/* MENU */}
      <div style={{ flex: 1, marginTop: collapsed ? "40px" : "0"  }}>
        {menuItems.map((item, i) => {
          const active = location.pathname.startsWith(item.link);

          return (
            <Link
              key={i}
              to={item.link}
              onClick={() => isMobile && setOpen(false)}
              title={collapsed ? item.name : ""}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "10px",
                borderRadius: "10px",
                marginBottom: "5px",
                textDecoration: "none",
                color: active ? "#fff" : "#94a3b8",
                  justifyContent: collapsed ? "center" : "flex-start", // ✅ FIX

                background: active
                  ? "linear-gradient(90deg,#6366f1,#8b5cf6)"
                  : "transparent",
                transition: "0.3s",
              }}
            >
              <i className={`bi ${item.icon}`} style={{    fontSize: "20px",
    minWidth: "20px",
    textAlign: "center", }} />

              {!collapsed && <span>{item.name}</span>}
            </Link>
          );
        })}
      </div>

      {/* FOOTER */}
      <button
  onClick={() => {
    handleLogout();
    window.location.reload(); // 👈 page refresh
  }}
  style={{
    background: "#fff",
    color: "#111",
    padding: "10px",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
  }}
>
  {!collapsed ? "Sign Out" : <i className="bi bi-box-arrow-right" />}
</button>
    </div>
  );
}

export default UserNav;
